export const localStorageSave = <T>(key: string, value: T): void => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (_) {}
};

export const localStorageGet = <T>(key: string): T | null => {
  try {
    const value = window.localStorage.getItem(key);

    if (value) {
      return JSON.parse(value) as T;
    }
  } catch (_) {}
  return null;
};

export const localStorageClear = (key: string): void => {
  try {
    window.localStorage.removeItem(key);
  } catch (_) {}
};
